// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"object-toolbar__main-section\">\n	<div class=\"object-toolbar__back\">\n		<button class=\"object-toolbar__back-button\">\n			<span class=\"icon-arrow-left\"></span>\n		</button>\n	</div>\n	<div id=\"object-toolbar-slider-region\" class=\"object-toolbar__slider\"></div>\n</div>\n";
},"useData":true});
